import { render, staticRenderFns } from "./stulist.vue?vue&type=template&id=0f6700bc&scoped=true"
import script from "./stulist.vue?vue&type=script&lang=js"
export * from "./stulist.vue?vue&type=script&lang=js"
import style0 from "./stulist.vue?vue&type=style&index=0&id=0f6700bc&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f6700bc",
  null
  
)

export default component.exports